import {ACTION_GET_USER_INFO} from '../../constant/eventbus'
import {USERCENTER_TICKET,MSITE_HDCN,MSITE_UUID} from '../../constant/CookieKeys'
import {api_logout} from '../../api/index'
import {url_without_ticket} from './ticket'
import * as Cookie from 'tiny-cookie';

export function login() {
  setTimeout(() => {
    if (gact.is_h5 || gact.debug) {
      clearCookie()
      window.location.href = `${gact.config.h5_login}?from= ${encodeURIComponent(url_without_ticket(window.location.href))}`;
    } else {
      MgtvApi.login(data => {
        const userInfo = data && JSON.parse(data);
        window.$bus.$emit(ACTION_GET_USER_INFO, userInfo.ticket);
      });
    }
  }, 100);
}



export function logout() {
  setTimeout(() => {
    clearCookie()
    if (gact.is_h5 || gact.debug) {
      window.location.href = `${gact.config.h5_login}?from= ${encodeURIComponent(url_without_ticket(window.location.href))}`;

    }
  }, 300);
}




function platForm() {
  const ua = window.navigator.userAgent;
  if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/WeiBo/i.test(ua)) {
    return 'weibo'
  } else if (/\sQQ/i.test(navigator.userAgent)) {
    return 'qq'
  }
  return 'unknow'
}

export function clearCookie(){
  Cookie.remove('HDCN', {domain: "mgtv.com"});
  Cookie.remove('uuid', {domain: "mgtv.com"});
  Cookie.remove('ticket', {domain: "mgtv.com"});
  Cookie.remove('vipStatus', { domain: "mgtv.com" });

  window.localStorage.removeItem('usercenter_t');

}


export function autoLogin() {
  if (gact.is_h5) {
    clearCookie();
    const link = encodeURIComponent(url_without_ticket(window.location.href))
    let loginUrl = null;
    let target = platForm();
    switch (target) {
      case 'weixin':
        loginUrl = 'https://club.api.mgtv.com/cj/weixin2/auth?dire_url=' + link
        break
      case 'weibo':
        loginUrl = 'https://club.api.mgtv.com/cj/oauth/weibo?dire_url=' + link
        break
      case 'qq':
        loginUrl = 'https://club.api.mgtv.com/cj/oauth/qq?dire_url=' + link
        break;
    }
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  }

}
